<template>
  <Form v-slot="{ errors }" @submit="onSubmit">
    <div class="pt-9 pb-[45px] pl-[33px] pr-[48px] min-w-[80vw] sm:min-w-[605px] w-full">
      <h5 class="text-[19px]/[22px] sm:text-[27px]/[31px] font-semibold font-raleway mb-4">
        Your information
      </h5>
      <div class="flex flex-col gap-4">
        <div
            v-for="(field, index) in yourInfo"
            :key="index"
            class="w-full flex flex-col justify-center relative"
        >
          <CustomField
              :name="field.field"
              :rules="[required, field.valid]"
              :placeholder="field.placeholder"
              :type="field.type"
              :options="field.options"
              :modelValue="field.value"
          />
          <span></span>
          <span class="text-red-500 text-xs pt-1">{{ errors[field.field] }}</span>
        </div>
      </div>
      <button
          class="mt-4 flex justify-center bg-vivid-purple w-full py-4 text-[21px]/[25px] text-white rounded-small font-bold hover:opacity-70  transition-all ease-in duration-150"
          :disabled="spinning"
      >
        <span
            v-if="spinning"
            class="px-[15px] cursor-pointer flex items-center bg-vivid-purple rounded-small justify-center w-full text-white gap-[13px] sm:gap-5 hover:opacity-70 transition-all duration-200 ease-linear [&_.loader]:!min-h-5 [&_.loader]:!h-5 [&_.item]:!w-6 [&_.item]:!h-6 [&_.item]:!border-2"
        >
          <CustomLoader/>
        </span>
        <span v-else>
          Update information
        </span>
      </button>
    </div>
  </Form>
</template>

<script lang="ts">
import {defineComponent, ref} from 'vue'
import {Form} from 'vee-validate'
import {required, emailValidation} from '@utills/helpers/validation'
import CustomField from '@components/reusable/CustomField.vue'
import {useUser} from "@stores/auth";
import CustomLoader from "@components/reusable/CustomLoader.vue";

export default defineComponent({
  components: {CustomLoader, Form, CustomField},
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  setup(props, {emit}) {
    const spinning = ref<boolean>(false)
    const {requestUserUpdateHandler} = useUser();

    const yourInfo = [
      {
        placeholder: 'Full name',
        field: 'name',
        valid: required,
        type: 'input',
        value: props.user.name ?? ''
      },
      {
        placeholder: 'Email',
        field: 'email',
        valid: emailValidation,
        type: 'input',
        value: props.user.email ?? ''
      },
      {
        placeholder: 'Phone',
        field: 'phone',
        valid: required,
        type: 'input',
        value: props.user.phone ?? ''
      },
      {
        placeholder: 'Preferred contact method',
        field: 'preferred_contact_method',
        valid: required,
        options: {
          'email': 'email', 'text': 'text', 'phone': 'phone'
        },
        type: 'select',
        value: props.user.preferred_contact_method ?? 'email'
      }
    ]


    const onSubmit = async (values: { [key: string]: string }) => {
      spinning.value = true
      await requestUserUpdateHandler(values);
      spinning.value = false
      emit('close')
    }

    return {
      spinning,
      yourInfo,
      required,
      emailValidation,
      onSubmit
    }
  }
})
</script>